<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-患者基础信息
-->

<template>
  <div class="clinic-index-page">
    <div class="top-desc">
      <div class="page-title">
        <img :src="iconTitle" alt="">
      </div>
      <div class="item-desc">
        <div class="item-text">
          <img :src="iconCheck" />
          <span>权威风险筛查</span>
        </div>
        <div class="item-text">
          <img :src="iconCheck" />
          <span>制定个性化干预方案</span>
        </div>
      </div>
    </div>
    <div class="page-bottom">
      <div class="card">
        <div class="title">个性化评估简介</div>
        <div class="card-content">
          <span class="normal-desc">完成问卷大概需要</span>
          <span class="high-desc">3~5分钟</span>
        </div>
        <div class="card-content">
          <span class="normal-desc">可以有效</span>
          <span class="high-desc">评估您的身体健康状态</span>
        </div>
      </div>
      <div class="card">
        <div class="title">健康评估说明</div>
        <div class="card-content">
          <span class="normal-desc">请您仔细阅读题目，根据自己的实际情况回答以下问题，并勾选对应的选项</span>
        </div>
      </div>
      <div class="footer">
        <van-button color="#FBB13D" type="primary" @click="toStart()" block round>开始评估</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import iconCheck from '@/assets/clinic/icon-check.png'
import iconTitle from '@/assets/clinic/icon-title.png'
export default {
  name: 'FormEntry',
  data() {
    return {
      iconCheck,
      iconTitle,
      hospitalInfo: {},
      id:4
    }
  },
  created() {

  },
  mounted() {
    
  },
  methods: {
    toStart() {
      console.log("1toStart")
      this.$emit('next-step',{type:'formEntry'})
    }
  },

};
</script>

<style scoped>
html {
  font-size: 24px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.clinic-index-page {
  width: 100%;
  height: 100vh;
  background-color: rgba(251, 177, 61, 0.2);
}

.top-desc {
  width: 100%;
  height: 9.33rem;
  padding: 2.08rem 1.58rem;
}

.top-desc .page-title {
  width: 23.3rem;
  height: 2.23rem;

}

.top-desc .page-title img {
  width: 100%;
  height: 100%;
}

.item-desc {
  margin-top: 1.5rem;
  width: 100%;
  height: 1.67rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2rem;
}

.item-desc .item-text {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.item-desc .item-text img {
  width: 1rem;
  height: 1rem;
  margin-right: 0.33rem;
}

.item-desc .item-text span {
  font-size: 1.17rem;
  color: #FBB13D;
}

.page-bottom {
  background-color: #fff;
  height: calc(100vh - 9.33rem);
  border-radius: 2rem 2rem 0 0;
  padding: 2rem;
  display: flex;
  flex-direction: column;
}
.card{
  width:20.17rem;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.67rem;
}
.card .title{
  height: 2.08rem;
  font-weight: 500;
  font-size: 1.5rem;
  color: #333333;
  line-height: 2.08rem;
}
.card .card-content span{
  height: 1.83rem;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
}
.card .card-content span.high-desc{
  color: #FBB13D;
}
.footer{
  flex:1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}
</style>
